//新闻
import axios from "axios"
export default {
    getNewsAsync: async (params) => {
        return axios.get('/get_news_list', {params:params})
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getDetailAsync: async (params) => {
        return axios.get('/get_news_detail', {params:params})
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    }
}

export function getNews(params){
    return axios.get('/get_news_list', {params:params})
}
